import { ref, set } from "firebase/database"
import { SESSION_SHUNT_PATH, SHUNT_ADJUSTDATA_MIXINGVESSEL_PATH } from "../../constants/firebasePaths"

export const addMixingVesselDataToShunt = (database, shuntID, size) => {
    const adjustmentRef = ref(database, SESSION_SHUNT_PATH + shuntID + SHUNT_ADJUSTDATA_MIXINGVESSEL_PATH);

    return set(adjustmentRef, size);
}